export const environment = {
  GD_QUIZZ_URL: 'https://quiz-diag-pro.lovable.app',
  production: true,
  HOST: 'https://api-dev.gestion-diagnostic.fr',
  logo_files:'https://storage.googleapis.com/logo_gestiondiag',
  stripe_public_key: "pk_test_FXSpRsGJ8EQqLcu0YuSy1uV4",
  FILE_UPLOADS: "https://storage.googleapis.com/gestiondiag.appspot.com",
  HOST_adresses: 'https://adresses.gestion-diagnostic.fr',
  GOOGLE_CLIENT_ID: '1047580682358-slgs970h6cgci12oqqc7mmhojdb1irpl.apps.googleusercontent.com',
  ENVIRONOT_PORTAL: 'https://portal.environot.fr',

};
//version gcloud
